import(/* webpackMode: "eager" */ "/kingsyard-ssr/src/app/(app)/resources/birding-journal/page.js");
